import React from "react";
import { Col, Form, Row, Select } from "antd";
import type { OriginPort } from "../../hooks/useOriginPorts";

type PortOption = Pick<OriginPort, "id" | "name"> & {
  country?: string | null;
};

type MasterContainerPortFieldsProps = {
  originPorts: PortOption[];
  destinationPorts: PortOption[];
  /** When true, both ports are required (e.g. create BL). */
  required?: boolean;
  /** Span for each Col; defaults to 12 (half width in a 24-gutter Row). */
  colSpan?: number;
};

/**
 * Shared origin / destination port selects for Master BL/AWB forms.
 */
export const MasterContainerPortFields: React.FC<
  MasterContainerPortFieldsProps
> = ({
  originPorts,
  destinationPorts,
  required = false,
  colSpan = 12,
}) => (
  <Row gutter={16}>
    <Col span={colSpan}>
      <Form.Item
        name="origin_port"
        label="Origin port"
        rules={
          required
            ? [{ required: true, message: "Please select origin port" }]
            : undefined
        }
      >
        <Select
          allowClear={!required}
          showSearch
          optionFilterProp="label"
          placeholder="Select origin port"
          options={originPorts.map((port) => ({
            value: port.id,
            label: port.country
              ? `${port.name} (${port.country})`
              : port.name,
          }))}
        />
      </Form.Item>
    </Col>
    <Col span={colSpan}>
      <Form.Item
        name="destination_port"
        label="Destination port"
        rules={
          required
            ? [{ required: true, message: "Please select destination port" }]
            : undefined
        }
      >
        <Select
          allowClear={!required}
          showSearch
          optionFilterProp="label"
          placeholder="Select destination port"
          options={destinationPorts.map((port) => ({
            value: port.id,
            label: port.country
              ? `${port.name} (${port.country})`
              : port.name,
          }))}
        />
      </Form.Item>
    </Col>
  </Row>
);
